var render, staticRenderFns
import script from "./ServerMembersChart.vue?vue&type=script&lang=js&"
export * from "./ServerMembersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae1e8e4",
  null
  
)

export default component.exports